app.controller(
    'WalkListController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'FlaneriesService', '$sce', '$translate', 'SideBarService', 'HelperService', '$window', 'AdminService', WalkListController]
);

function WalkListController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, FlaneriesService, $sce, $translate, SideBarService, HelperService, $window, AdminService) {
    var vm = this;
     vm.isAllSelected = false;
    $scope.$parent.type = 'walk';
    $translate.use($rootScope.LangForInterface);
    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }

    if ($stateParams.qc) {
        vm.ParamQcId = $stateParams.qc;
    }
    else {
        vm.ParamQcId = 6560;   //24h
    }
    

    $rootScope.UpdateRoles();

    vm.ItineraryList = []; //declare an empty array
    vm.pageno = 1; // initialize page no to 1
    vm.total_count = 0;

    vm.direction = "ascending";
    vm.reverse = false;
    vm.SearchVM = {};
    $rootScope.TopBarAction = {};
    $rootScope.TopBarAction.isActive = false;
    $rootScope.BatchReplaceTextResult = null;
    vm.itemsPerPage = 15; //this could be a dynamic value from a drop down

    vm.getsearchurlparam = function (zoneId, pageno, sortKey, reverse, isTopBarActive, searchText, SearchVM) { // This would fetch the data on page change.

        if (SearchVM.Reset) {
            vm.SearchParam = "";
        }
        else {
            vm.SearchParam = HelperService.GetSearchUrlParam(SearchVM);
        }
        SearchVM.Reset = false;
        $window.location.href = $rootScope.interfaceSubFolder+ '/#!/list/walk?z=' + zoneId + '&qc=' + vm.ParamQcId + '&pageno=' + pageno + '&sortkey=' + sortKey + '&reverse=' + reverse + '&istopbaractive=' + isTopBarActive + '&searchText=' + searchText + vm.SearchParam;

    };


    vm.getDataV2 = function () { // This would fetch the data on page change.

        vm.ItineraryList = [];
        if ($stateParams.z != null)
            vm.ParamZoneId = $stateParams.z;

        if ($stateParams.pageno != null)
            vm.pageno = $stateParams.pageno;

        if ($stateParams.reverse != null)
            vm.reverse = $stateParams.reverse;

        if ($stateParams.sortkey != null)
            vm.sortKey = $stateParams.sortkey;

        if ($stateParams.istopbaractive != null)
            $rootScope.TopBarAction.isActive = $stateParams.istopbaractive;

        if ($stateParams.searchText != null)
            $rootScope.TopBarAction.SearchText = $stateParams.searchText;
        else
            $rootScope.TopBarAction.SearchText = "";

        if ($rootScope.TopBarAction.isActive == 'true')
            $scope.showDetail('rechercher');
        else
            $scope.closeDetail('rechercher');
        if ($stateParams.mcd != null) {
            vm.ParamMcd = $stateParams.mcd;
        }
        if ($stateParams.qc) {
            vm.ParamQcId = $stateParams.qc;
        }
        else {
            vm.ParamQcId = 6560;   //24h
        }

        //Allow change position or not
        if (($rootScope.TopBarAction.isActive == false || $rootScope.TopBarAction.isActive == "false") && ($stateParams.gsearch == null || $stateParams.gsearch == undefined || $stateParams.gsearch == "undefined") && ($stateParams.search == null || $stateParams.search == undefined || $stateParams.search == "undefined") && ($rootScope.RoleForDragAndDropPosition.includes($rootScope.globals.currentUser.RoleId))) {
            vm.AllowChangePosition = true;
            vm.sortKey = "SortInZone";
        }
        else {
            vm.AllowChangePosition = false;
            vm.sortKey = "ItineraryTitle";
        }

        //Get List 

        var promiseGetList = FlaneriesService.GetItineraryList(vm.ParamZoneId, vm.ParamQcId, vm.itemsPerPage, vm.pageno, vm.sortKey, vm.reverse, $rootScope.LangForWork, $rootScope.TopBarAction.isActive, $stateParams.search, $stateParams.gsearch, $stateParams.searchText, vm.SearchVM);
        promiseGetList.then(function (response) {
            vm.ItineraryList = response.data.ItineraryList;  // data to be displayed on current page.
            $rootScope.InitListSelectedId(vm.ItineraryList, 'walk', vm);
            vm.total_count = response.data.total_count; // total data count.
            $rootScope.total_count = response.data.total_count;
            vm.SearchVM = response.data.SearchVM;
            $rootScope.SideBarSearchVM = vm.SearchVM
            //$scope.ChangeZoneById(vm.ParamZoneId);
            $rootScope.TopBarAction.StatusList = $rootScope.StatusList4WorkflowObject;
            $rootScope.TopBarAction.ClientList = angular.copy(vm.SearchVM.Client);
        });
    };


    vm.getData = function (zoneId, ParamQcId, pageno, sortKey, reverse, isTopBarActive, searchText, SearchVM) { // This would fetch the data on page change.
     $window.location.href = $rootScope.interfaceSubFolder + '/#!/list/walk?z=' + zoneId + '&qc=' + ParamQcId + '&pageno=' + pageno + '&sortkey=' + sortKey + '&reverse=' + reverse + '&istopbaractive=' + isTopBarActive + '&searchText=' + searchText + '&search=' + $stateParams.search + '&gsearch=' + $stateParams.gsearch;

    };
    vm.getDataV2();

    $scope.$parent.search = $stateParams.search;
    $scope.$parent.gsearch = $stateParams.gsearch;
    $scope.$parent.qc = $stateParams.qc;
    $scope.$parent.sortkey = vm.sortKey;
    $scope.$parent.reversesort = vm.reverse;

    // $scope.vm = vm;

    $scope.sort = function (keyname) {
        vm.sortKey = keyname;   //set the sortKey to the param passed
        vm.reverse = !vm.reverse; //if true make it false and vice versa
        vm.getData(vm.ParamZoneId, vm.ParamQcId, vm.pageno, keyname, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, vm.SearchVM);
    }

    vm.getUserUrl = function (setId, lang, index, sortKey, reverse, filter) {
        var urlDynamique = '/#!/consultation/walk?id=';
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Author) {
            urlDynamique = "/#!/consultation/walk?id=";
        }
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Corrector) {
            urlDynamique = "/#!/correction/walk?id=";
        }
        if ($rootScope.globals.currentUser.RoleId == $rootScope.EnumRole.Translator) {
            urlDynamique = "/#!/traduction/itinary?lang2=" + $rootScope.LangForTranslationDestination + "&id=";
        }
     return $rootScope.interfaceSubFolder + urlDynamique + setId + "&lang=" + lang + "&index=" + index + "&sortKey=" + sortKey + "&reverse=" + reverse + "&z=" + $stateParams.z;
    }


    $rootScope.AdvancedSearch = function AdvancedSearch() {
        $rootScope.TopBarAction.isActive = false;
        $rootScope.resetSelectedListId();
        vm.getsearchurlparam(vm.ParamZoneId, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, $rootScope.SideBarSearchVM);
    };


    $rootScope.GlobalAdvancedSearch = function GlobalAdvancedSearch(key, value) {
        if (value != null) {
            $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key] = value;
            $rootScope.SideBarSearchVM.GlobalSearch.Keyword = "";
            $rootScope.AdvancedSearch();
        }
    };

    $rootScope.removeTags = function (key) {
        //$rootScope.SideBarSearchVM.GlobalSearch.SearchValues.splice(key, 1);
        delete $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key];
        $rootScope.AdvancedSearch();
        //$rootScope.$apply();
    };
    $rootScope.ShowResultBeforeReplace = function () {
        $rootScope.TopBarAction.isActive = true;
        vm.getData(vm.ParamZoneId, vm.ParamQcId, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, $rootScope.SideBarSearchVM);
    }

    $rootScope.BatchReplaceText = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.ItineraryList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Itinerary;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;
        if ($rootScope.TopBarAction.IdList.length > 0 && $rootScope.TopBarAction.SearchText != undefined && $rootScope.TopBarAction.ToReplaceText != undefined) {
            SideBarService.BatchReplaceText($rootScope.TopBarAction)
            .then(
                    function success(data) {
                    },
                    function error(data) { });
        }
    }

    $rootScope.BatchModifyClient = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.ItineraryList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Itinerary;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;

        SideBarService.BatchModifyClient($rootScope.TopBarAction)
        .then(
                function success(data) {
                    window.location.reload();
                },
                function error(data) { });
    }

    $rootScope.BatchModifyStatus = function () {
        $rootScope.TopBarAction.IdList = GetSelectedIdList(vm.ItineraryList, 'Id');
        $rootScope.TopBarAction.ObjectType = $rootScope.EnumLinkType.Itinerary;
        $rootScope.TopBarAction.Lang = $rootScope.LangForWork;

        SideBarService.BatchModifyStatus($rootScope.TopBarAction)
        .then(
                function success(data) {
                    window.location.reload();
                },
                function error(data) { });
    }

    //Drag and Drop - Start    
    vm.sortableOptions = {
        update: function (e, ui) {
            var oldIndex = ui.item.sortable.index;
            var newIndex = ui.item.sortable.dropindex;
            if (oldIndex != newIndex) {
                HelperService.UpdateObjectPositionInZone(vm.ItineraryList[oldIndex].Id, vm.ParamZoneId, (vm.pageno - 1) * vm.itemsPerPage + oldIndex + 1, (vm.pageno - 1) * vm.itemsPerPage + newIndex + 1, $rootScope.EnumLinkType.Itinerary).
                then(
                    function success(data) {
                        //window.location.reload();
                        //vm.getData(vm.ParamZoneId, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, $rootScope.SideBarSearchVM);
                    },
                    function error(data) { });
            }
        },
        handle: '> .dragHandle',
        'ui-floating': false,
        placeholder: "trholder",
        containment: "parent",
        opacity: 0.3,
        //snap: "tr",
        //snapMode: "outer",
        helper: fixHelper,
        tolerance: "pointer"
    };
    //Drag and Drop - End
};